export default __webpack_public_path__ + "static/media/departed-by-vessel.106146db.svg";